
import { Component, Prop, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMQuestionnaire } from "@/store";
import { TSocItem_Details } from "@/models/soc_items";
import { API_TCaseCategory } from "@/models/case_profiles";
import { REmployerHomeNew } from "@/pages/Layout/views/Employer/views/HomeNew/REmployerHome";

@Component({
  components: {
    ProfileTemplate: () => import("@/components/ProfileTemplate/ProfileTemplate.vue"),
  },
})
export default class JobTemplate extends Vue {
  @Prop({ type: Array }) readonly src?: API_TCaseCategory[];
  @Prop({ type: Object }) readonly details?: TSocItem_Details;
  @Prop({ type: Boolean, default: true }) readonly isEditable?: boolean;

  get isRoleEditable() {
    return this.isEditable;
  }

  async roleTemplateEditCheck(payload: { caseId: number; stepId: number }) {
    const { caseId, stepId } = payload;

    if (!caseId || !stepId) return;

    const { data } = await this.axios.get(API_ROUTES.ROLE_TEMPLATE_EDIT_CHECK(caseId));

    if (!data) return (this.notCompletedTaskDialog.visible = true);

    return await this.confirmQuestionEditing(payload);
  }

  async confirmQuestionEditing(payload: { caseId: number; stepId: number }) {
    try {
      const { caseId, stepId } = payload;

      if (!caseId || !stepId) return;

      const { data } = await this.axios.get(API_ROUTES.ROLE_TEMPLATE_EDIT_STEP(caseId, stepId));

      if (!data) return;

      SMQuestionnaire.setAnswerQuery({ target_id: data.target_user_id });

      await SMQuestionnaire.openQuestionnaire(data.ID);
    } catch (e) {
      console.log("confirmQuestionEditing error:", e);
    }
  }

  notCompletedTaskDialog = {
    visible: false,
    title: this.$tc("dialog.task.title"),
    text: this.$tc("dialog.task.text"),
  };

  viewNotCompletedTasks() {
    this.$router.push({ name: REmployerHomeNew.name });
  }
}
